import { choose } from '../../utils/platform';
import JoinFamilyDesktop from './JoinFamily.desktop';
import JoinFamilyMobile from './JoinFamily.mobile';

// Platform chooser: phone (APK or narrow browser) gets the full-screen list.
export default choose(JoinFamilyDesktop, JoinFamilyMobile);
